import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from './material.module';
import { CalendarNavComponent } from './components/calendar-nav/calendar-nav.component';
import { StatusSelectComponent } from './components/status-select/status-select.component';
import { ModalHeaderComponent } from './components/modal-header/modal-header.component';
import { DatetimeFieldComponent } from './components/datetime-field/datetime-field.component';
import { DatepickerComponent } from './components/datepicker/datepicker.component';
import { TimepickerComponent } from './components/timepicker/timepicker.component';
import { SelectFieldComponent } from './components/select-field/select-field.component';
import { CaretimeFieldComponent } from './components/caretime-field/caretime-field.component';
import { EditFooterComponent } from './components/edit-footer/edit-footer.component';
import { EditHeaderComponent } from './components/edit-header/edit-header.component';
import { StatusFieldComponent } from './components/status-field/status-field.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { MultipleSelectFieldComponent } from './components/multiple-select-field/multiple-select-field.component';
import { CameraFieldComponent } from './components/camera-field/camera-field.component';
import { ModalFooterComponent } from './components/modal-footer/modal-footer.component';
import {
  ModalMenuComponent,
  ModalMenuWrapper,
} from './components/modal-menu/modal-menu.component';
import {
  DialogComponent,
  DialogWrapper,
} from './components/dialog/dialog.component';
import { KidsPicker } from './custom-date-formats';
import { DialDialogComponent, PadPipe } from './components/timepicker/dial-dialog/dial-dialog.component';
import { ShareDirectiveModule } from '@care-connect-japan/ckweblib';
import { TitleChangeComponent } from './components/title-change/title-change.component';
import { DialogFooterComponent } from './components/dialog-footer/dialog-footer.component';
import { CommonDialogComponent } from './components/common-dialog/common-dialog.component';

const components = [
  CommonDialogComponent,
  DialogFooterComponent,
  KidsPicker,
  PadPipe,
  DialDialogComponent,
  CalendarNavComponent,
  StatusSelectComponent,
  ModalHeaderComponent,
  ModalFooterComponent,
  EditHeaderComponent,
  EditFooterComponent,
  StatusFieldComponent,
  DatepickerComponent,
  TimepickerComponent,
  DatetimeFieldComponent,
  SelectFieldComponent,
  CaretimeFieldComponent,
  MultipleSelectFieldComponent,
  CameraFieldComponent,
  ConfirmDialogComponent,
  ModalMenuComponent,
  ModalMenuWrapper,
  DialogComponent,
  DialogWrapper,
  TitleChangeComponent
];

const modules = [BrowserAnimationsModule, ReactiveFormsModule, MaterialModule, ShareDirectiveModule, FormsModule];

@NgModule({
  declarations: [...components],
  imports: [CommonModule, ...modules],
  exports: [...components, ...modules, KidsPicker],
})
export class SharedModule { }
